<template>
    <div :class="classNames">
        <p class="region-confirm__question">
            <span>Ваш город<span class="d-none d-sm-inline"> —</span></span>
            {{ currentCity }}
            <strong class="d-none d-sm-inline">?</strong>
        </p>
        <div class="region-confirm__actions">
            <button @click.prevent="showConfirmRegion" class="region-confirm__btn btn btn-sm btn-outline-main-second" type="button" data-toggle="modal" data-target="#regionModal">
                <span>Выбрать другой</span>
            </button>
            <button @click.prevent="confirmRegion" class="region-confirm__btn btn btn-main btn-sm" type="button">
                <span>Да, верно</span>
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'region-confirm',

    inject: ['$userGeoService'],

    props: {
        currentCity: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            show: false,
            confirmed: this.$userGeoService.checkRegionConfirmed(),

            settledRegion: this.$userGeoService.getSettledRegion(),
        };
    },

    computed: {
        classNames() {
            return {
                'region-confirm': true,
                'region-confirm--show': this.show,
                'region-confirm--confirmed': this.confirmed,
            };
        },
    },

    methods: {
        confirmRegion() {
            this.$userGeoService.confirmRegion();
            this.show = false;
            document.body.classList.remove('page--region-modal');
            if (window.innerWidth <= 576) {
                $('#regionConfirmModal').modal('hide');
            }
        },

        showConfirmRegion() {
            if (window.innerWidth <= 576) {
                $('#regionConfirmModal').modal('hide');
                $('#regionModal').modal('show');
            }
        },
    },

    mounted() {
        setTimeout(() => {
            if (!this.confirmed) {
                this.show = true;
                document.body.classList.add('page--region-modal');
                if (window.innerWidth <= 576) {
                    $('#regionConfirmModal').modal('show');
                }
            }
        }, 1000);
    },
};
</script>
